import { render, staticRenderFns } from "./beiyun.vue?vue&type=template&id=b8179e7c&"
import script from "./beiyun.vue?vue&type=script&lang=ts&"
export * from "./beiyun.vue?vue&type=script&lang=ts&"
import style0 from "./beiyun.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports